import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

// Voucher package API. Every call returns the raw normalized response object
// from `dataAccess` ({ message, responseCode, data, error } on success,
// { response: { message, ... } } on failure) — callers test
// `response?.responseCode === 200`.
const PKG = `${API_CONSTANTS.VOUCHER}/package`; // .../admin/voucher/package

// ---------------------------------------------------------------------------
// Package CRUD + export
// ---------------------------------------------------------------------------

// params: { search, status, page, limit, mallId }. `status` is UPPERCASE
// (ACTIVE | SCHEDULED | SOLD_OUT | EXPIRED | DEACTIVATED); omit it for "all" —
// fetchData drops undefined/null/'' params. `limit` is capped at 100 server-side.
export const getPackageList = async (params = {}) => {
  return await fetchData(`${PKG}/list`, params);
};

export const getPackageDetail = async (id) => {
  return await dataAccess.get(`${PKG}/detail?id=${id}`);
};

export const createPackage = async (data) => {
  return await dataAccess.post(`${PKG}/create`, { data });
};

// data.id is required; data may carry removeVoucherIds.
export const updatePackage = async (data) => {
  return await dataAccess.put(`${PKG}/update`, { data });
};

export const deletePackage = async (id) => {
  return await dataAccess.del(`${PKG}/delete?id=${id}`);
};

// Same params as getPackageList. Returns { jobId }; poll getPackageExportStatus.
export const exportPackages = async (params = {}) => {
  return await fetchData(`${PKG}/export`, params);
};

// Deliberately NOT the shared export-status helper in api/export.js: that
// route resolves to the reporting permission, and the axios interceptor clears
// local storage and redirects to login on a 401 — a voucher-only admin polling
// it would be logged out mid-export. This route sits under /admin/voucher/ and
// inherits the voucher permission.
export const getPackageExportStatus = async (jobId) => {
  return await dataAccess.get(
    `${API_CONSTANTS.VOUCHER}/package/export-status/${jobId}`
  );
};

// ---------------------------------------------------------------------------
// Mixed admin rows (plain vouchers + package rows, Phase 3 endpoints)
// ---------------------------------------------------------------------------

// params: { id | phone, page, limit, bucket?, restorationDate?, deletionDate? }
export const getCustomerAdminRows = async (params = {}) => {
  return await fetchData(
    `${API_CONSTANTS.CUSTOMER}/package/voucher-list`,
    params
  );
};

// params: { search, startDate, endDate (YYYY-MM-DD), page, limit }
export const getReservedAdminRows = async (params = {}) => {
  return await fetchData(`${PKG}/reserved-list`, params);
};

// ---------------------------------------------------------------------------
// Collect and cancel
// ---------------------------------------------------------------------------

// data: { phoneNumber, purchaseId, vouchers: [{ voucherId, voucherCode,
// serialNumber }] } — one to fifty lines. A 400 may carry data.errors[].
export const collectPackage = async (data) => {
  return await dataAccess.put(`${API_CONSTANTS.CUSTOMER}/package/collect`, {
    data,
  });
};

// customerId is the server's stale-tab cross-check; always send it.
export const cancelPackage = async (purchaseId, customerId) => {
  return await dataAccess.put(
    `${PKG}/cancel?purchaseId=${purchaseId}&customerId=${customerId}`
  );
};

// items: [{ type: 'package', purchaseId, customerId } |
//         { type: 'voucher', id, customerId }] — one to a hundred, `type` mandatory.
export const bulkCancelPackages = async (items) => {
  return await dataAccess.put(`${PKG}/bulk-cancel`, { data: { items } });
};
